function createSlotContent(slotName, content, tag = "span") {
  const element = document.createElement(tag);
  if (slotName !== void 0) {
    element.setAttribute("slot", slotName);
  }
  if (typeof content === "string") {
    element.textContent = content;
  } else {
    element.appendChild(content);
  }
  return element;
}
function getSlotElements(host, slotName) {
  if (slotName === void 0 || slotName === "default") {
    return Array.from(host.children).filter(
      (child) => !child.hasAttribute("slot")
    );
  }
  return Array.from(host.children).filter(
    (child) => child.getAttribute("slot") === slotName
  );
}
function isAllowedElement(element, allowed) {
  const tagName = element.tagName.toLowerCase();
  return allowed.some((pattern) => {
    if (pattern === "h*") {
      return /^h\d+$/.test(tagName);
    }
    return tagName === pattern.toLowerCase();
  });
}
function assertSlot(host, slotName, options) {
  const shouldExist = options?.exists ?? true;
  const elements = getSlotElements(host, slotName);
  if (shouldExist && elements.length === 0) {
    throw new Error(`assertSlot: slot "${slotName}" expected content but found none`);
  }
  if (!shouldExist && elements.length > 0) {
    throw new Error(`assertSlot: slot "${slotName}" expected no content but found ${elements.length} element(s)`);
  }
  if (options?.count !== void 0 && elements.length !== options.count) {
    throw new Error(
      `assertSlot: slot "${slotName}" expected ${options.count} element(s) but found ${elements.length}`
    );
  }
  if (options?.allowedElements && elements.length > 0) {
    for (const el of elements) {
      if (!isAllowedElement(el, options.allowedElements)) {
        throw new Error(
          `assertSlot: slot "${slotName}" contains disallowed element <${el.tagName.toLowerCase()}>. Allowed: ${options.allowedElements.join(", ")}`
        );
      }
    }
  }
}
export {
  assertSlot,
  createSlotContent,
  getSlotElements,
  isAllowedElement
};
//# sourceMappingURL=slots.js.map
